import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Field, Control, Select, Icon } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "react-apollo";
import { ALL_BOOKING_CODES_QUERY } from "../../graphql/BookingCodes/BookingCodes.graphql";

const BookingCodeSelect = ({
  name,
  value,
  onChange,
  where = {},
  icon,
  disabled = false,
  minimal = false,
  size = "",
  defaults = { label: "All", value: 0 },
  filterBooked = false,
  isBookable = true,
  required = false,
  disableDefaults = true
}) => {
  const [color, setColor] = useState(undefined);

  const { data: BookingCodeData, loading, error } = useQuery(
    ALL_BOOKING_CODES_QUERY,
    {
      variables: { where, orderByMulti: ["BookingCode_ASC"] }
    }
  );
  const getSelectOptionLabel = BookingCode => {
    if (minimal) {
      return filterBooked
        ? BookingCode.Description.replace("Booked - ", "")
        : BookingCode.Description;
    }
    return `${BookingCode.BookingCode} - ${BookingCode.Description}`;
  };
  useEffect(() => {
    if (BookingCodeData && Array.isArray(BookingCodeData.BookingCodes)) {
      const selected = BookingCodeData.BookingCodes.find(
        code => code.RecId === parseInt(value)
      );
      if (selected) {
        setColor(selected.Color);
      } else {
        setColor(undefined);
      }
    }
  }, [BookingCodeData, value]);
  return (
    <Field>
      <Control iconLeft={!!icon}>
        {/* {label && <Label>{label}</Label>} */}
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : "secondary"
          }
          size={size}
          state={loading ? "loading" : null}
        >
          <Select
            disabled={disabled}
            name={name}
            required={required}
            value={value || undefined}
            onChange={onChange}
          >
            <Select.Option
              selected
              disabled={disableDefaults}
              value={defaults.value}
            >
              {defaults.label}
            </Select.Option>
            {!loading &&
              BookingCodeData &&
              BookingCodeData.BookingCodes &&
              BookingCodeData.BookingCodes.filter(
                x => isBookable || !x.Description.includes("Booked")
              ).map((BookingCode, i) => (
                <Select.Option
                  key={`booking-code-select-${i}`}
                  value={BookingCode.RecId}
                >
                  {getSelectOptionLabel(BookingCode)}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left">
            <FontAwesomeIcon color={color} icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
};

BookingCodeSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  where: PropTypes.object,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  minimal: PropTypes.bool,
  size: PropTypes.string,
  defaults: PropTypes.object,
  filterBooked: PropTypes.bool,
  isBookable: PropTypes.bool,
  required: PropTypes.bool,
  disableDefaults: PropTypes.bool
};
export default BookingCodeSelect;
